<template>
    <div>
        <breadCrumb
            :icon="'fa-chart-line'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_setting_staff`)"
            :subSubCategory="''">
        </breadCrumb>
        <!-- <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportSalesTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul> -->
        <!-- <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <salesFilter
                        ref="salesFilter"
                        :tab="selectedTab"
                        :commissionSalesItem="commissionItems"
                        @filterSalesCommission="filterSalesCommission"
                        @openStaffPositionPopup="openStaffPositionPopup"
                        @openServicePopup="openServicePopup">
                    </salesFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <salesItem ref="salesItem" :commissionSalesItem="commissionItems" @setExportData="setExportData"></salesItem>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div :class="{ 'show': isModalShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{ $t('message.data.fetching_wait') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <staffPopup ref="staffPopup" @modalClose="modalClose"></staffPopup>
        <servicePopup ref="servicePopup" @modalClose="modalClose"></servicePopup>
    </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import Swal from "sweetalert2";
import _ from 'lodash';
import SalesFilter from './Sales_Filter'
import SalesItem from './Sales_Item'
import SalesDate from './Sales_Date'
import BreadCrumb from './../../../Bread_Crumb'
import box from './../../../../../assets/js/dashboard/salonReport/salonReport'
import { formatPrice } from './../../../../../assets/js/dashboard/utilities'
import { handleSessionExpired, setSummaryBoxLabel } from './../../../../../assets/js/dashboard/dashboard'
import StaffPopup from './StaffPopup'
import ServicePopup from './ServicePopup'
export default {
    name: "reportSales",
    components: {
        // SalesFilter,
        // SalesItem,
        BreadCrumb,
        StaffPopup,
        ServicePopup,
    },
    data() {
        return {
            salesReportSummaryBox: [],
            selectedTab: "date",
            isModalShow: false,
            commissionItems: [],
            showSummaryBox: true,
            currentFilter: {},
        }
    },
    watch: {
        selectedTab(value) {
            // this.$refs.salesFilter.setExportData(this.commissionItems, value);
            this.filterSalesCommission(this.currentFilter)
        },
        "$i18n.locale"(val) {
            this.setSummaryBoxLabel()
        }
    },
    methods: {
        setExportData(result) {
            if (result) {
                this.$refs.salesFilter.setExportData(result, this.selectedTab);
            }
        },

        async filterSalesCommission(filter) {
            // this.currentFilter = filter

            // this.isModalShow = true;

            // let url = `https://mall.tunai.io/report/VIISkin/sales?start=${this.currentFilter.startDate.format('DD/MM/YYYY')}&end=${this.currentFilter.endDate.format('DD/MM/YYYY')}`
            // if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
            //     // this.currentFilter.startDate = moment('2024-06-27', 'YYYY-MM-DD').startOf('day')
            //     // this.currentFilter.endDate = moment('2024-06-27', 'YYYY-MM-DD').endOf('day')
            //     url = `http://localhost:5001/report/VIISkin/sales?start=${this.currentFilter.startDate.format('DD/MM/YYYY')}&end=${this.currentFilter.endDate.format('DD/MM/YYYY')}`
            // }

            // if (this.currentFilter.outlet && this.currentFilter.outlet !== 'all') {
            //     url += '&outletID=' + this.currentFilter.outlet
            // }

            // if (this.currentFilter.itemType && this.currentFilter.itemType !== 'all') {
            //     url += '&type=' + this.currentFilter.itemType
            // }

            // if (this.currentFilter.staff && this.currentFilter.staff !== 'all') {
            //     url += '&staff=' + this.currentFilter.staff
            // }

            // this.$axios({
            //     method: 'get',
            //     url: url,
            //     headers: { token: this.$util.getSessionToken() }
            // })
            //     .then((response) => {
            //         this.isModalShow = false;

            //         var results = response.data;
            //         this.$refs.salesItem.updateTable(results, this.currentFilter);
            //     })
            //     .catch((err) => {
            //         this.isModalShow = false;

            //         var errData = err.response.data;
            //         if (errData.error == this.$api.INVALID_TOKEN) {
            //             handleSessionExpired();
            //         }
            //     })
        },

        openStaffPositionPopup() {
            this.$refs.staffPopup.open()
        },
        openServicePopup() {
            this.$refs.servicePopup.open()
        },
        modalClose() {
            this.filterSalesCommission(this.currentFilter)
        },
    },
    mounted() {
        let $vm = this;
        var data = {
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month'),
            outlet: "all",
            search: "",
            type: "",
            itemType: "all",
            category: "all",
            folderID: "all"
        }

        $vm.filterSalesCommission(data)

        this.$refs.staffPopup.open()
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}

.modal-content {
    background: transparent;
    box-shadow: none;
}

.show {
    display: block;
}
</style>